import { calcularForcaDeChoque, type ResultadoForcaDeChoque } from './forcaDeChoque'
import { MATERIAIS_TALABARTE, ORDEM_MATERIAIS, type MaterialTalabarte } from './materiaisTalabarte'
import { ENSAIO_REFERENCIA, REDUTORES_FORCA, type TipoRedutor } from './redutoresForca'

/**
 * O ensaio de referência: a mesma massa, a mesma queda e o mesmo comprimento de
 * corda para qualquer material e redutor, para comparar os sistemas numa
 * régua só. Usa o cálculo da força de choque; não é um ensaio.
 */

export interface ResultadoEnsaio {
  readonly material: MaterialTalabarte
  readonly redutor: TipoRedutor
  readonly resultado: ResultadoForcaDeChoque
  readonly criterioKN: number
  readonly passa: boolean
  /** Do talabarte esticar ao ponto mais baixo. */
  readonly distanciaDeParadaM: number
}

export interface OpcoesEnsaio {
  /** A força e a abertura do absorvedor do trabalhador, usadas quando o redutor é o absorvedor. */
  readonly absorvedor: { readonly forcaKN: number; readonly aberturaM: number }
}

export function rodarEnsaioReferencia(material: MaterialTalabarte, redutor: TipoRedutor, opcoes: OpcoesEnsaio): ResultadoEnsaio {
  const dados = REDUTORES_FORCA[redutor]
  const resultado = calcularForcaDeChoque({
    massaKg: ENSAIO_REFERENCIA.massaKg,
    quedaLivreM: ENSAIO_REFERENCIA.quedaLivreM,
    comprimentoM: ENSAIO_REFERENCIA.comprimentoCordaM,
    rigidezEAkN: MATERIAIS_TALABARTE[material].rigidezEAkN,
    forcaAbsorvedorKN: dados.forcaKN ?? opcoes.absorvedor.forcaKN,
    aberturaMaximaAbsorvedorM: dados.aberturaM ?? opcoes.absorvedor.aberturaM,
  })
  return {
    material,
    redutor,
    resultado,
    criterioKN: ENSAIO_REFERENCIA.valor,
    passa: resultado.forcaPicoKN <= ENSAIO_REFERENCIA.valor,
    distanciaDeParadaM: resultado.descidaAposEsticarM,
  }
}

/** O ensaio para os quatro materiais, com o redutor dado. */
export function ensaioDeTodosOsMateriais(redutor: TipoRedutor, opcoes: OpcoesEnsaio): readonly ResultadoEnsaio[] {
  return ORDEM_MATERIAIS.map((m) => rodarEnsaioReferencia(m, redutor, opcoes))
}
